import { createFileRoute } from '@tanstack/react-router';

import { PortalCompanyProfilePage } from '@/modules/portal/pages/PortalCompanyProfilePage';

export const Route = createFileRoute('/account/company-profile/')({
  component: PortalCompanyProfilePage,
});
